import { Button, fontMedium } from "swing-components";

/**
 * Renders when there is no matching configuration. This happens when a Sub that
 * is not allowed to use the new onboarding flow tries to access the new
 * onboarding flow.
 *
 * The UI simply redirects the user to the old Swing Subs application.
 */
export function InvalidConfiguration() {
  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        gap: 16,
        padding: "120px 32px",
        maxWidth: 800,
        margin: "0 auto",
      }}
    >
      {/*
        NOTE: Given that this page is temporary, we will not move this
        content into the string-table.ts file.
       */}
      <p css={[fontMedium({ fontWeight: 600 }), { margin: 0 }]}>Continue Swing setup</p>
      <p css={[fontMedium(), { margin: 0 }]}>
        You'll continue your setup at{" "}
        <a href="https://subs.swingeducation.com">subs.swingeducation.com</a>. If the page doesn't
        load automatically, <a href="https://subs.swingeducation.com">click here</a> to continue.
      </p>
      <Button
        type="primary"
        onClick={() => (window.location.href = "https://subs.swingeducation.com")}
      >
        Take me there
      </Button>
    </div>
  );
}
